import { client } from '@api/client';
import { URL } from '@api/urls';

import { IDefaultUploadUrlApi } from '@interfaces/common/file';

const { createUploadUrlAttachment } = URL;

export const getUploadURLAttachment = ({ fileName }: IDefaultUploadUrlApi) =>
	client.post(`/${createUploadUrlAttachment}`, {
		fileName,
	});
